import * as XLSX from "xlsx";
import moment from "moment";
import { extractExamFromMetadata } from "../../utils/metadata";
import { PhoneNumber } from "../../utils/phoneNumber";

const findConclusion = (exam: Exam): string => {
  // if (!exam) return "Invalido";

  const conclusion =
    exam?.form.find((field) => field.type === "conclusiones")?.response
      ?.input_value || "otro";

  return conclusion.replaceAll("_", " ").toUpperCase();
};

const findExam = (appointment: any) => {
  return extractExamFromMetadata(appointment.metadata);
};

const findConclusionComents = (exam: Exam): string => {
  const conclusionComments = exam?.form.find((field) => field.type === "textarea")?.response
    ?.input_value || null;

  return conclusionComments
}


const returnDateTime = (rowData: any) => {
  if (rowData?.type === 'Visita a Domicilio' || rowData?.type === 'Videollamada') return "---";
  if (rowData?.startTime) return `${rowData.date} - ${rowData?.startTime}`;
  return "---";
}

const returnAppType = (rowData: any) => {
  if (rowData?.type) return rowData.type;
  if (rowData?.isPrestador) return 'Turno Externo'
  return 'Control en Lavoris';
}


const returnAdmissionDate = (rowData: any) => {
  if (rowData?.admissionTime) return rowData?.admissionTime;
  if (rowData?.report?.visitManualTime) return rowData?.report?.visitManualTime;
  return "---";
}





const employeeResult = (item: any) => {
  const forms = item?.metadata?.simplified
    ?.map((s: any) => s.form)
    ?.filter(Boolean);

  const findControlEnConsultorio = (formArray: any) =>
    formArray?.find((e: any) => e?.label === 'Control en Consultorio');

  let diagnosticoFinal: string | null = null;

  forms?.some((formArray: any) => {
    const controlEnConsultorio = findControlEnConsultorio(formArray);

    // Diagnóstico en Control en Consultorio
    if (controlEnConsultorio) {
      const diagnosticoField = formArray?.find((e: any) =>
        e?.label === 'Diagnosticos' || e?.label === 'Diagnósticos'
      );
      const diag = diagnosticoField?.response?.input_value?.label?.trim();
      if (diag) {
        diagnosticoFinal = diag.replace(/,/g, '');
        return true; // sale del some
      }
    }

    // Interconsulta Traumatológica
    const isICTraumatologica = formArray?.find((e: any) =>
      e?.label === 'Interconsulta Traumatológica'
    );
    if (isICTraumatologica) {
      const result = formArray?.find((e: any) => e?.label === 'Informe');
      if (result?.response?.input_value) {
        diagnosticoFinal = result.response.input_value;
        return true;
      }
    }

    // Interconsulta Neurológica
    const isICNeurologica = formArray?.find((e: any) =>
      e?.label === 'Interconsulta Neurologica'
    );
    if (isICNeurologica) {
      const result = formArray?.find((e: any) => e?.label === 'Informe');
      if (result?.response?.input_value) {
        diagnosticoFinal = result.response.input_value;
        return true;
      }
    }

    return false; // sigue buscando en otros formularios
  });

  return diagnosticoFinal || "---";
};


const absenteeResult = (item: any) => {
  if (!item) return;
  const report = item?.report;
  const diagnostico = report?.diagnostic;
  return diagnostico
}

const returnDiagnostics = (rowData: any) => {
  if ((rowData?.patient && rowData?.patient?.type === 'EMPLOYEE') || (rowData?.patient && rowData?.patient.employee)) {
    return employeeResult(rowData)
  };

  if (rowData?.type && (rowData?.type === 'Visita a Domicilio' || rowData?.type === 'Videollamada')) {
    return absenteeResult(rowData)
  };

  return "---"
}

const controlConsultorio = (item: any) => {
  const formatDateSafe = (dateValue: any) => {
    if (!dateValue) return '---';

    // Si ya viene en formato DD/MM/YYYY lo devolvemos tal cual
    const regexDMY = /^\d{2}\/\d{2}\/\d{4}$/;
    if (regexDMY.test(dateValue)) {
      return dateValue;
    }

    // Si viene como "Fecha inválida"
    if (typeof dateValue === "string" && dateValue.toLowerCase().includes("inválida")) {
      return '---';
    }

    // Si viene en formato ISO u otro válido para moment
    const m = moment(dateValue);
    return m.isValid() ? m.format("DD/MM/YYYY") : '---';
  };
  if ((item?.patient?.type === 'EMPLOYEE') || (item?.patient && item?.patient?.employee)) {
    const simplified = item?.metadata?.simplified
    const form = simplified
      ?.map((s: any) => s.form)
      ?.filter((f: any) => f !== undefined);


    const findControlEnConsultorio = (formArray: any) => {
      return formArray?.find((element: any) => element?.label === 'Control en Consultorio')
    };


    const examenFisico = form?.map((a: any) => {
      const controlEnConsultorio = findControlEnConsultorio(a);
      if (controlEnConsultorio && controlEnConsultorio !== undefined) {
        const exFisico = a?.find((element: any) => element?.label === "Examen Físico");
        if (exFisico) {
          return exFisico?.response?.input_value;
        }
        return
      }
    })
    const estadoAtencion = form?.map((a: any) => {
      const controlEnConsultorio = findControlEnConsultorio(a);
      if (controlEnConsultorio && controlEnConsultorio !== undefined) {
        const estadoAtencion = a?.find((element: any) => element?.label === "Estado de la atención");
        if (estadoAtencion) {
          return estadoAtencion?.response?.input_value;
        }
        return
      }
    })

    const fechaAlta = form?.map((a: any) => {
      const controlEnConsultorio = findControlEnConsultorio(a);
      if (controlEnConsultorio && controlEnConsultorio !== undefined) {
        const fechaAlta = a?.find((element: any) => element?.label === "Fecha" || element?.label === "Fecha de alta");
        if (fechaAlta) {
          return moment(fechaAlta?.response?.input_value).format('DD/MM/YYYY');
        }
        return
      }
    })

    const inasistenciaJust = form?.map((a: any) => {
      const controlEnConsultorio = findControlEnConsultorio(a);
      if (controlEnConsultorio && controlEnConsultorio !== undefined) {
        const inasistenciaJust = a?.find((element: any) => element?.label === "¿Inasistencia Justificada?");
        if (inasistenciaJust) {
          return inasistenciaJust?.response?.input_value
        }
        return
      }
    })

    const diasJust = form?.map((a: any) => {
      const controlEnConsultorio = findControlEnConsultorio(a);
      if (controlEnConsultorio && controlEnConsultorio !== undefined) {
        const inasistenciaJust = a?.find((element: any) => element?.label === "Días justificados");
        if (inasistenciaJust) {
          return inasistenciaJust?.response?.input_value
        }
        return
      }
    })
    return { examenFisico, estadoAtencion, fechaAlta, inasistenciaJust, diasJust }
  }
  if (item?.type && (item?.type === 'Visita a Domicilio' || item?.type === 'Videollamada')) {

    const report = item?.report;
    const examenFisico = report?.physicalExamination;
    const estadoAtencion = item?.status;
    const inasistenciaJust = report?.isAbsenceJustified ? 'Si' : 'No';
    const fechaAlta = report?.isAbsenceJustified ? formatDateSafe(report?.releaseDate) : '---'
    const diasJust = report?.isAbsenceJustified ? report?.absenceDaysJustifiedByLavoris : '---';
    return { examenFisico, estadoAtencion, fechaAlta, inasistenciaJust, diasJust }
  }
  return '---'
}


const accidenteLaboral = (item: any) => {
  if ((item?.patient?.type === 'EMPLOYEE') || item?.patient?.employee) {
    const forms = item?.metadata?.simplified
      ?.map((s: any) => s.form)
      ?.filter(Boolean);

    // Buscar el formulario que tenga Placa, Laboratorio y Vacuna Antitetanica
    const targetForm = forms?.find((form: any[]) =>
      form.some((f) => f.label === "Placa") &&
      form.some((f) => f.label === "Laboratorio") &&
      form.some((f) => f.label === "Vacuna Antitetanica")
    );

    if (!targetForm) return undefined;

    // Función auxiliar para obtener valor después de un título (select, calendar, text, etc.)
    const getValueAfterTitle = (title: string) => {
      const index = targetForm.findIndex((f: any) => f.label === title);
      if (index === -1) return null;

      const nextField = targetForm.slice(index + 1).find(
        (f: any) => ["select", "calendar", "text"].includes(f.type)
      );

      return nextField?.response?.input_value ?? null;
    };

    const placaValue = getValueAfterTitle("Placa");
    const laboratorioValue = getValueAfterTitle("Laboratorio");
    const vacunaValue = getValueAfterTitle("Vacuna Antitetanica");
    const denunciaArt = getValueAfterTitle("Denuncia ART");
    const observacion = getValueAfterTitle("Observacion");
    const altaControl = getValueAfterTitle("Alta/Control");

    // Ahora tomamos la fecha después de Alta/Control (que está en calendar)
    const fechaAltaControl = (() => {
      const altaIndex = targetForm.findIndex((f: any) => f.label === "Alta/Control");
      if (altaIndex === -1) return null;
      const fechaField = targetForm.slice(altaIndex + 1).find(
        (f: any) => f.type === "calendar"
      );
      return fechaField?.response?.input_value ?? null;
    })();

    return {
      placa: placaValue,
      laboratorio: laboratorioValue,
      vacunaAntitetanica: vacunaValue,
      denunciaArt,
      observacion,
      altaControl,
      fechaAltaControl: moment(fechaAltaControl).format("DD/MM/YYYY")
    };
  }

  return {
    placa: "---",
    laboratorio: "---",
    vacunaAntitetanica: "---",
    denunciaArt: "---",
    observacion: "---",
    altaControl: "---",
    fechaAltaControl: "---"
  };
};


const returnPracticeName = (rowData: any) => {
  const simplified = rowData?.metadata?.simplified || [];

  // Caso especial: Visita a Domicilio o Videollamada
  if (rowData?.type === 'Visita a Domicilio' || rowData?.type === 'Videollamada') {
    return rowData?.practiceName || '---';
  }

  // Caso especial: Asistencia Medica por Accidente
  const accidentePractice = simplified.find(
    (practice: any) => practice.alias === 'ASISTENCIA_MEDICA_POR_ACCIDENTE'
  );
  if (accidentePractice) {
    return accidentePractice.name;
  }

  // Si no es accidente, devolver todos los nombres en simplified
  if (simplified.length > 0) {
    return simplified.map((practice: any) => practice.name).join(', ');
  }

  return '---';
};

const wsEnviado = (rowData: any) => {
  if (!rowData?.actions || rowData?.actions?.length === 0) return 'No';

  const ws_enviado = rowData?.actions.filter((action: any) => action.action === "PDF-WS-ENVIADO" || action.action === 'PDF-WS-REENVIADO');
  if (ws_enviado.length === 0) return 'No';
  return 'Si';
};


const professional = (item: any) => {
  const metadata = item?.metadata
  const molde = metadata?.molde || [];
  const exam = metadata?.exam || [];
  const practices = metadata?.practices || [];
  const simplified = metadata?.simplified || [];
  const isAbsentee = item.type === 'Visita a Domicilio' || item.type === 'Videollamada'
  let professional = null;
  let allowExam: string[] = [];

  if ((molde?.name?.includes('Medico en planta')) && (item.status !== 'Eliminado' || item.status !== 'Ausente')) {
    allowExam = ['PRACTICE_IN_MOLDE']
    professional = simplified?.filter((p: any) => allowExam.includes(p.type))[0]?.professional
    if (professional) {
      return `${professional?.title} ${professional?.name}`
    }
  }

  if ((metadata && practices.length === 1) && (item.status !== 'Eliminado' || item.status !== 'Ausente')) {
    professional = simplified?.filter((p: any) => p.type === 'PRACTICE')[0]?.professional
    if (professional) {
      return `${professional?.title} ${professional?.name}`
    }
  }

  if ((metadata && practices.length > 1) && (item.status !== 'Eliminado' || item.status !== 'Ausente')) {
    professional = simplified?.map((p: any) => p).map((prof: any) => prof.professional);

    if (professional.length > 1) {
      // Mapear para obtener la propiedad que necesitas de cada objeto y separarlos con un guion
      professional = professional.map((p: any) => `${p?.title} ${p?.name}`).join(' - ');
      return professional;
    }
  }



  if ((molde || exam) && (item.status !== 'Eliminado' || item.status !== 'Ausente')) {
    allowExam = ['EXAM', 'EXAM_IN_MOLDE']
    professional = simplified?.filter((p: any) => allowExam.includes(p.type))[0]?.professional
    if (professional) {
      return `${professional?.title} ${professional?.name}`
    }
  }

  if (isAbsentee && item.status === 'Completada') {
    const professional_abbreviation = item?.['specialist.abbreviation']
    const professional_name = item?.['specialist.name']
    return `${professional_abbreviation}  ${professional_name}`
  }

  return '---'
}
const personalInformation = (item: any) => {
  let name: string = '---';
  let dni: string = '---';
  let phone: string = '---';
  let puesto: string = '---';
  let fullAddress: string = '---';
  let province: string = '---';
  let patient: any = item?.patient;
  let metadata_patient: any = item?.metadata?.patient;

  if (item?.type === 'Visita a Domicilio' || item?.type === 'Videollamada') {
    name = item?.['employee.name']?.toUpperCase() || '---';
    dni = item?.['employee.DNI'] || '---';
    phone = PhoneNumber(item?.['employee.phoneNumber']) || '---';
    puesto = item?.['employee.positionName'] || '---';
    fullAddress = item?.['employee.fullAddress'] || '---';
    province = item?.['employee.province'] || '---';
  } else {
    name = patient?.user?.name?.toUpperCase() || metadata_patient?.name?.toUpperCase() || '---';
    dni = patient?.user?.DNI || metadata_patient?.dni || '---';
    phone = PhoneNumber(patient?.employee?.phoneNumber) || PhoneNumber(metadata_patient?.phone) || '---';
    puesto = patient?.employee?.positionName || metadata_patient?.positionName || '---';
    fullAddress = patient?.employee?.fullAddress || '---';
    province = patient?.employee?.province || '---';
  }

  return { name, dni, phone, puesto, fullAddress, province }

}

const home_pickup_questions = (item: any) => {
  let was_at_home: string = '---';
  let pick_up_call: string = '---';
  let visit_address: string = '---'
  let report = item.report;

  if (item?.type === 'Visita a Domicilio' || item?.type === 'Videollamada') {
    was_at_home = report.isPatientAtHome ? 'Si' : 'No';
    pick_up_call = report.answeredCall ? 'Si' : 'No';
    visit_address = item?.fullAddress;
  }
  return { was_at_home, pick_up_call, visit_address }
}



const cm = (item: any) => {
  const DEFAULT = "---";

  const formatDateSafe = (dateValue: any) => {

    if (!dateValue) return DEFAULT;

    // Si ya viene en formato DD/MM/YYYY lo devolvemos tal cual
    const regexDMY = /^\d{2}\/\d{2}\/\d{4}$/;
    if (regexDMY.test(dateValue)) {
      return dateValue;
    }

    // Si viene como "Fecha inválida"
    if (typeof dateValue === "string" && dateValue.toLowerCase().includes("inválida")) {
      return DEFAULT;
    }

    // Si viene en formato ISO u otro válido para moment
    const m = moment(dateValue);

    return m.isValid() ? m.format("DD/MM/YYYY") : DEFAULT;
  };


  let hasCMValue = item?.has_cm;
  let certificate_professional_name = DEFAULT;
  let certificate_professional_license = DEFAULT;
  let certificate_professional_date: any = DEFAULT;
  let certificate_professional_days = DEFAULT;

  const report = item?.report;

  // --- 1) Prioridad REPORT ---
  if (report && report?.presentsCertificate !== undefined) {
    hasCMValue = report.presentsCertificate;
    certificate_professional_name = report.certificateProfessionalName || DEFAULT;
    certificate_professional_license = report.certificateProfessionalLicense || DEFAULT;
    certificate_professional_date = report.certificateDate || DEFAULT;
    certificate_professional_days = report.certificateJustifiedDays || DEFAULT;
  }

  // --- 2) Prioridad SIMPLIFIED (solo si NO hay report) ---
  else if ((item?.patient?.type === "EMPLOYEE") || (item?.patient?.employee)) {
    const simplified = item?.metadata?.simplified;
    const form = simplified
      ?.map((s: any) => s.form)
      ?.filter((f: any) => f !== undefined);

    const findControlEnConsultorio = (formArray: any) =>
      formArray?.find((element: any) => element?.label === "Control en Consultorio");

    form?.forEach((a: any) => {
      const controlEnConsultorio = findControlEnConsultorio(a);
      
      if (controlEnConsultorio) {
        const has_cm = a?.find((e: any) => e?.label === "¿Presenta certificado médico?");
        if (has_cm?.response?.input_value !== undefined) {
          hasCMValue = has_cm.response.input_value === "Si";
        }

        const prof_name = a?.find((e: any) => e?.label === "Apellido, Nombre del profesional CM");
        if (prof_name?.response?.input_value) certificate_professional_name = prof_name.response.input_value;

        const prof_license = a?.find((e: any) => e?.label === "Matrícula del profesional CM");
        if (prof_license?.response?.input_value) certificate_professional_license = prof_license.response.input_value;

        const prof_date = a?.find((e: any) => e?.label === "Fecha CM");
        if (prof_date?.response?.input_value) certificate_professional_date = prof_date.response.input_value;

        const prof_days = a?.find((e: any) => e?.label === "Días justificados CM" || e?.label === "Días otorgados CM" || e?.label === "Días otorgados en CM");
        
        if (prof_days?.response?.input_value) certificate_professional_days = prof_days.response.input_value;
      }
    });

    // Si simplified no trae valor para algún campo, completar con item
    if (certificate_professional_name === DEFAULT && item?.professional_cm) {
      certificate_professional_name = item.professional_cm;
    }
    if (certificate_professional_license === DEFAULT && item?.professional_license_cm) {
      certificate_professional_license = item.professional_license_cm;
    }
    if (certificate_professional_date === DEFAULT && item?.cm_date) {
      certificate_professional_date = item.cm_date;
    }
    if (certificate_professional_days === DEFAULT && item?.cm_days) {
      certificate_professional_days = item.cm_days;
    }
  }

  // --- 3) Prioridad ITEM (solo si no hay report ni simplified) ---
  else {
    if (item?.professional_cm) certificate_professional_name = item.professional_cm;
    if (item?.professional_license_cm) certificate_professional_license = item.professional_license_cm;
    if (item?.cm_date) certificate_professional_date = item.cm_date;
    if (item?.cm_days) certificate_professional_days = item.cm_days;
  }

  return {
    present_cm: hasCMValue ? "Si" : "No",
    certificate_professional_name: hasCMValue ? certificate_professional_name : DEFAULT,
    certificate_professional_license: hasCMValue ? certificate_professional_license : DEFAULT,
    certificate_professional_date: hasCMValue ? formatDateSafe(certificate_professional_date) : DEFAULT,
    certificate_professional_days: certificate_professional_days || DEFAULT,
  };
};





const absenteeExcelReport = async (rowData: any) => {
  if (rowData.length === 0 || !rowData) return

  const headers = [
    "Compañía",
    "Nombre",
    "DNI",
    "Puesto",
    'Teléfono',
    "Domicilio",
    "Provincia",
    "Tipo de atención",
    "Fecha de solicitud del servicio o atención médica",
    "Fecha y hora de admisión / visita / videollamada",//SERIA EL FECHA Y HORA DE VISITA MANUAL
    "Práctica",
    "Domicilio de visita",//AGREGO ESTO, PORQUE PUEDE SER DISTINTO A LA DIRECCION DEL EMPLEADO, NO?
    "¿Estaba en domicilio?",
    "Atendió la llamada?",
    "¿Presenta CM?",
    "Profesional CM",
    "Matricula CM",
    "Fecha CM",
    "Días otorgados CM",
    "Profesional Lavoris",
    "Resultado - Diagnóstico",
    "Examen Físico",
    "Estado de la atención",
    "Inasistencia justificada",
    "Días justificados",
    "Fecha de alta",
    //CASO QUE SEA ACCIDENTE LABORAL
    "¿Se pide placa?",
    "¿Se pide laboratorio?",
    "¿Antitetánica?",
    "¿Denuncia ART?",
    "Alta/Control",
    "Fecha alta/control",
    "Observaciones-Examen físico",
    //Para todos los casos
    "Estado del servicio-prestación",
    "WS - Envio de constacia"
  ];

  const excelDataPromises = rowData?.map(async (item: any) => {
    const socialReason = item?.metadata?.patient?.companySocialReason?.toUpperCase() || item?.employee?.company?.socialReason?.toUpperCase() || item?.['employee.company_socialReason']?.toUpperCase() || "---";
    const appType = returnAppType(item);
    const appStatus = item?.status;
    const requestedDate = moment(item.createdDate).format('DD/MM/YYYY HH:mm') || "---";
    const addmissionDateTIme = returnAdmissionDate(item)
    const diagnostics = returnDiagnostics(item) || "---";
    const controlConsultorioResult = controlConsultorio(item);



    return [
      socialReason,
      personalInformation(item).name,
      personalInformation(item).dni,
      personalInformation(item).puesto,
      personalInformation(item).phone,
      personalInformation(item).fullAddress,
      personalInformation(item).province,
      appType,
      requestedDate,
      addmissionDateTIme,

      returnPracticeName(item),
      home_pickup_questions(item).visit_address,
      home_pickup_questions(item).was_at_home,
      home_pickup_questions(item).pick_up_call,

      cm(item).present_cm,
      cm(item).certificate_professional_name,
      cm(item).certificate_professional_license,
      cm(item).certificate_professional_date,
      cm(item).certificate_professional_days,

      professional(item),
      //Control Lavoris (Consultorio - Calle)
      diagnostics,
      ...(typeof controlConsultorioResult === 'object' ? [
        controlConsultorioResult.examenFisico,
        controlConsultorioResult.estadoAtencion,
        controlConsultorioResult.inasistenciaJust,
        controlConsultorioResult.diasJust,
        controlConsultorioResult.fechaAlta
      ] : ['---']),
      // ACCIDENTE LABORAL
      accidenteLaboral(item)?.placa,
      accidenteLaboral(item)?.laboratorio,
      accidenteLaboral(item)?.vacunaAntitetanica,
      accidenteLaboral(item)?.denunciaArt,
      accidenteLaboral(item)?.altaControl,
      accidenteLaboral(item)?.fechaAltaControl,
      accidenteLaboral(item)?.observacion,
      appStatus,
      wsEnviado(item)
    ]
  })
  const excelData = await Promise.all(excelDataPromises);

  // Asegurarse de que todo sea texto
  const formattedExcelData = excelData.map(row => row.map((cell: any) => ({ v: cell, z: '@' })));

  const ws = XLSX.utils.aoa_to_sheet([headers.map(header => ({ v: header, z: '@' })), ...formattedExcelData]);

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const date = moment().format('DD/MM/YYYY');
  let filename = `Reportes-Servicios-Prestaciones-Ausentismo-${date}.xlsx`;

  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();

  return excelDataPromises;

}

export default absenteeExcelReport